module.exports = __webpack_public_path__ + "img/zeelab2.357446f4.png";